import React from 'react';
import PropTypes from 'prop-types';

import { ButtonsCollection, ModalWindow } from '../../../../ui-kit';
import './style.sass';

const DeleteFileModal = ({
  isOpen,
  isPending,
  onCloseModal,
  onDeleteTaskFile,
  t,
}) => (
  <ModalWindow
    isOpen={isOpen}
    onClose={onCloseModal}
    className="delete-task__modal"
    title={t('Delete file')}
    modalName={t('Delete file')}
  >
    <>
      <div className="row  text-align--left">
        <span className="delete-task__title title-md">
          {t('Are you sure you want to delete this file ?')}
        </span>
      </div>
      <div className="delete-task__button-row">
        <ButtonsCollection.ButtonBrill
          className="button-brill--fill task-files__add-button  button--sm"
          type="submit"
          onClick={onDeleteTaskFile}
          disabled={isPending}
        >
          {t('Delete')}
        </ButtonsCollection.ButtonBrill>
        <button
          type="button"
          className="button--cancel"
          onClick={onCloseModal}
        >
          {t('Cancel')}
        </button>
      </div>
    </>
  </ModalWindow>
);

DeleteFileModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isPending: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onDeleteTaskFile: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default DeleteFileModal;
